/* eslint-disable flowtype/no-types-missing-file-annotation */
export const ACTIONS = {
    DELETE: "delete",
    MAKE_ADMIN: "makeAdmin",
    MAKE_USER: "makeUser",
    REMOVE: "remove"
};

export type actionType = "delete" | "makeAdmin" | "makeUser" | "remove";
